import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowRight, Clock} from 'lucide-react';
const guides = require('../seo/guides.json');

export default function GuidesPage() {
  const entries = Object.values(guides);

  return (
    <div data-testid="guides-page" className="bg-slate-50 min-h-[60vh]">
      <section className="bg-slate-900 text-white py-14 sm:py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 data-testid="guides-title" className="text-4xl sm:text-5xl font-black mb-4">Guides pratiques de chantier</h1>
          <p className="text-slate-300 text-base max-w-3xl leading-relaxed">
            Méthode, matériel et erreurs à éviter : nos guides reprennent ce que nous expliquons chaque semaine au
            dépôt de Cauville-sur-Mer, à 15 minutes du Havre et d'Étretat. De quoi préparer votre chantier avant même
            de réserver votre machine.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 py-12 sm:py-16">
        <div className="grid gap-6 sm:grid-cols-2">
          {entries.map(guide => (
            <Link
              key={guide.slug}
              to={`/guides/${guide.slug}`}
              data-testid={`guide-card-${guide.slug}`}
              className="bg-white border border-slate-100 rounded-xl overflow-hidden hover:border-green-300 hover:shadow-lg transition-all"
            >
              <img src={guide.image} alt={guide.h1} loading="lazy" className="w-full h-44 object-cover" />
              <div className="p-5">
                <p className="text-green-700 text-xs font-semibold uppercase tracking-wide mb-2">{guide.category}</p>
                <h2 className="text-base md:text-lg font-bold text-slate-800 mb-2">{guide.h1}</h2>
                <p className="text-sm text-slate-600 line-clamp-3">{guide.description}</p>
                <p className="mt-4 flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1 text-slate-500"><Clock size={14} />{guide.readTime}</span>
                  <span className="flex items-center gap-1 text-green-700 font-semibold">Lire le guide <ArrowRight size={14} /></span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
